import CryptoJS from "crypto-js";
const sign = 'e07157b7b815bf2b3add52523f95326b';
// 接口验签
export const toSign = (obj: any) => {
    // 按照升序排序obj属性
    const sortObj = obj;
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
        // 遍历newkey数组
        newObj[newkey[i]] = sortObj[newkey[i]];
        // 向新创建的对象中按照排好的顺序依次增加键值对
    })
    const keyArr = new Array();
    for (const y in newObj) {
        if (true) {
            const x = newObj[y];
            if (typeof newObj[y] === "object") {
                keyArr.push(y + "=" + JSON.stringify(x.map(String)))
            } else {
                keyArr.push(y + "=" + x)
            }
        }
    }
    const keySign = keyArr.join("&");
    const result = CryptoJS.HmacSHA1(keySign, sign).toString(CryptoJS.enc.Hex);
    newObj.sign = result
    return newObj;
}
